import { createElement } from '@airwallex/components-sdk'
import parsePhoneNumber from 'libphonenumber-js'

import { BankingUseCaseErrors } from '../BankingUseCaseErrors'
import { AIRWALLEX_COMPONENTS_THEME } from '../constants'

export class VerifyIdentityUseCase {
  constructor(private deps: {}) {}

  execute = async ({
    mountElementId,
    scaSessionCode,
    onVerified,
    onError,
    onCancel,
    email,
    phoneNumber = '',
  }: {
    mountElementId: string
    scaSessionCode?: string
    onVerified: (scaToken: string) => void
    onError: (error: Error) => void
    onCancel: () => void
    email: string
    phoneNumber?: string
  }) => {
    try {
      const parsedPhoneNumber = parsePhoneNumber(phoneNumber)

      const scaElement = await createElement('scaVerify', {
        userEmail: email,
        prefilledMobileInfo: {
          countryCode: parsedPhoneNumber?.countryCallingCode ?? '',
          nationalNumber: parsedPhoneNumber?.nationalNumber ?? '',
        },
        scaSessionCode,
        theme: AIRWALLEX_COMPONENTS_THEME,
      })

      const containerElement = document.getElementById(mountElementId)
      if (containerElement) scaElement.mount(containerElement)

      scaElement.on('scaSetupSucceed', async ({ mobileInfo }) => {
        scaElement.unmount()

        const scaVerifyElement = await createElement('scaVerify', {
          userEmail: email,
          prefilledMobileInfo: mobileInfo,
          scaSessionCode,
          theme: AIRWALLEX_COMPONENTS_THEME,
        })

        if (containerElement) scaVerifyElement.mount(containerElement)

        scaVerifyElement.on('verificationSucceed', ({ token }) => {
          onVerified(token)
        })
      })

      scaElement.on('verificationSucceed', ({ token }) => {
        onVerified(token)
      })
      scaElement.on('verificationFailed', ({ reason }) => {
        onCancel()
        onError(new Error(reason))
      })
      scaElement.on('error', (e) => {
        onError(new Error(e.message))
      })
      scaElement.on('cancel', () => {
        onCancel()
      })
    } catch (error) {
      throw new BankingUseCaseErrors({
        name: 'ERROR_RENDERING_AIRWALLEX_SCA_COMPONENT',
        message: 'Failed to render Airwallex SCA component',
      })
    }
  }
}
